import { Term } from './term';
import { parseUTCDate, ensureChronologicalOrder } from '../../utils/date-utils/date-utils';

export class CourseInfo {
  id: string;
  instanceId: string;
  academicYear: string;
  startDate: Date;
  endDate: Date;
  terms: Term[];

  constructor(data: Partial<Record<Exclude<keyof CourseInfo, 'id'>, any>>) {
    Object.assign(this, data);

    this.startDate = parseUTCDate(data.startDate);
    this.endDate = parseUTCDate(data.endDate);
    
    [this.startDate, this.endDate] = ensureChronologicalOrder(this.startDate, this.endDate);

    this.id = `course-data-${this.startDate.getTime()}-${this.endDate.getTime()}`;
  }
}
